import React from 'react';
import PropTypes from 'prop-types';
import styles from './benefitsCarousel.module.scss';

const BenefitsCarousel = ({
  children,
  couponText,
  loading,
  isLoggedIn,
  isPremiumMember,
  offset
}) => {
  const [active, setActive] = React.useState(1);

  const handleScroll = (e) => {
    window.requestAnimationFrame(() => {
      const documentScrollLeft = e.target.scrollLeft;

      setActive(Math.round(documentScrollLeft / offset) + 1);
    });
  };

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        active: active,
        offset: offset,
        loading: loading,
        isLoggedIn: isLoggedIn,
        isPremiumMember: isPremiumMember,
        couponText: couponText
      });
    }
    return child;
  });

  return (
    <div className={styles.benefitsCarousel}>
      <div onScroll={handleScroll} className={styles.carousel}>
        {childrenWithProps}
      </div>
    </div>
  );
};

BenefitsCarousel.propTypes = {
  loading: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isPremiumMember: PropTypes.bool,
  couponText: PropTypes.any,
  children: PropTypes.node,
  offset: PropTypes.number
};

export default BenefitsCarousel;
